/****************************************************
 * Module Name:  WolzaIndiaExportProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class WolzaIndiaExportProxy {

    static GetWolzaDetail = (consigneeid, callback) => {
        let params = {
            consigneeid: consigneeid,
        };
        restAPICall(
            Constants.UTILITY_URL + "/wolza/consignee",
            "get",
            undefined,
            params,
            undefined,
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetWolzaDetailsByCriteria = (data, callback) => {
        restAPICall(
            Constants.UTILITY_URL + `/wolza/fetch/marketsell/criteria`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetCustomersWolzaDetails = (customerid, data, stoneType, callback) => {
        restAPICall(
            Constants.UTILITY_URL + `/wolza/customer/${customerid}/detail/${stoneType}`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetConsigneeWolzaDetails = (consigneeid, data, stoneType, callback) => {
        restAPICall(
            Constants.UTILITY_URL + `/wolza/consignee/${consigneeid}/detail/${stoneType}`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetMarketSell = (data, callback) => {
        restAPICall(
            Constants.UTILITY_URL + `/wolza/fetch/marketsell`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetDetailedMarketSell = (data, callback) => {
        restAPICall(
            Constants.UTILITY_URL + `/wolza/fetch/detailed/marketsell`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };


    static GetStonePotential = (data, callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/wolza/stonepotential/stoneids",
            "post",
            undefined,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetMarketStonePotentialForStoneForMappedUser = (stoneid, data, stonetype, callback) => {
        restAPICall(
            Constants.UTILITY_URL + `/wolza/fetch/market/potential/mappeduser/stone/${stoneid}/${stonetype}`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetMarketStonePotentialForStoneForUnMappedUser = (stoneid, data, stonetype, callback) => {
        restAPICall(
            Constants.UTILITY_URL + `/wolza/fetch/market/potential/unmappeduser/stone/${stoneid}/${stonetype}`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}
